import BusinessCardTile from "@/components/BusinessCardTile";
import { Button } from "@/components/ui/button";
import { SkipForward } from "lucide-react";
import { cn } from "@/lib/utils";
import { useDataContext } from "@/app/_context";
import { useEffect } from "react";

export default function BusinessCard(props: { show?: boolean }) {
  // Retrieve data from context
  const {
    isPaused: isPlayerPaused,
    currentProjectInfo,
    setWasBusinessCardShown,
    setIsBusinessCardPlaying,
    isPortal,
  } = useDataContext();

  const userLogoUrl = currentProjectInfo.logoUrl;
  const { socialAccount1, socialAccount2, socialAccount3 } = currentProjectInfo;

  // Create an array of valid social accounts (non-empty strings)
  const socialAccounts = [
    socialAccount1,
    socialAccount2,
    socialAccount3,
  ].filter((account) => account && account.trim() !== "");

  useEffect(() => {
    console.log(currentProjectInfo);
  }, []);

  return (
    <div
      id="BusinessCard"
      className="h-full pointer-events-none flex w-full relative"
    >
      <div
        className={cn(
          "absolute pointer-events-auto z-10 bottom-0 pb-2",
          isPortal ? "pb-[11%] left-[4%]" : "pb-12 right-12",
        )}
      >
        <Button
          onClick={() => {
            setWasBusinessCardShown(true);
            setIsBusinessCardPlaying(false);
          }}
          className={
            "rounded-none md:text-xl !bg-gray-800/60 !tracking-relaxed !text-white p-3"
          }
        >
          Skip <SkipForward className="h-4 w-4 ml-2 lg:h-8 lg:w-8" />
        </Button>
      </div>
      <div className="w-[38%] p-4">
        <img src={userLogoUrl} className="h-8" />
      </div>
      <div
        className={cn(
          isPortal && "pt-12",
          "w-full flex-1 flex items-center justify-center p-2 pb-[60px]",
        )}
      >
        <div className="aspect-square max-h-full w-full grid grid-cols-2 grid-rows-2 p-6 gap-6">
          {socialAccounts.map((socialHref, index) => (
            <BusinessCardTile key={index} socialHref={socialHref} />
          ))}
          <BusinessCardTile merch />
          {Array.from({ length: Math.max(0, 3 - socialAccounts.length) }).map(
            (_, i) => (
              <div
                key={`empty-${i}`}
                className="rounded-md bg-white/5 h-full w-full"
              />
            ),
          )}
        </div>
      </div>
    </div>
  );
}
